import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Text, Heading, Button } from 'wix-style-react';
import s from './Enterprise.scss';
import { EnterpriseRefContext } from 'providers/EnterpriseContextProvider';

export const EnterpriseHeader: React.FC = () => {
  const { t } = useTranslation();
  const { scrollToRef } = React.useContext(EnterpriseRefContext);
  return (
    <div className={s.headerContainer}>
      <div className={s.headerInnerContainer}>
        <Heading
          className={s.headerTitle}
          appearance='H2'
          dataHook='enterprise-tab-title'
        >
          {t('enterprise_plans.body.header')}
        </Heading>
        <Text className={s.headerSubtitle}>
          {t('enterprise_plans.body.text')}
        </Text>
        <Button
          dataHook='enterprise-tab-request-call-btn'
          size='large'
          className={s.headerButton}
          onClick={scrollToRef}
        >
          {t('enterprise_plans.button.request_a_call')}
        </Button>
      </div>
      <div
        className={s.headerVisual}
        role='img'
        aria-label={t('enterprise_plans.tab.img.alt')}
      ></div>
    </div>
  );
};
